import { useState, useEffect } from 'react'

// Global target time to keep all instances synchronized
// 10 minutes and 43 seconds = 643 seconds
const INITIAL_SECONDS = 643
let globalTargetTime: number | null = null

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_SECONDS)

  useEffect(() => {
    // Initialize global target time only once
    if (!globalTargetTime) {
      globalTargetTime = Date.now() + INITIAL_SECONDS * 1000
    }

    const interval = setInterval(() => {
      if (!globalTargetTime) return

      const now = Date.now()
      const difference = globalTargetTime - now

      if (difference <= 0) {
        setTimeLeft(0)
        clearInterval(interval)
      } else {
        setTimeLeft(Math.floor(difference / 1000))
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60

    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    }
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }

  return {
    timeLeft,
    formattedTime: formatTime(timeLeft),
    isExpired: timeLeft === 0,
  }
}
